// src/redux/slices/categorySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';



const BASE_URL = process.env.REACT_APP_BASE_URL || "https://hefnawy.brmjatech.co.uk/api";


// دالة مساعدة للحصول على التوكن
const getAuthToken = () => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("userElqma"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }
    if (!token) {
      token = storedUser?.result?.token;
    }

    return token;
  } catch (error) {
    return null;
  }
};

export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (page = 1, thunkAPI) => {
    try {
     
      
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const url = `${BASE_URL}/client_categories?page=${page}`;

      const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
      });

      return response.data;
    } catch (error) {

      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error fetching categories"
      );
    }
  }
);

// Update category
export const updateCategory = createAsyncThunk(
  "category/updateCategory",
  async ({ id, formData }, thunkAPI) => {
    try {

      
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.post(
        `${BASE_URL}/update_new_category/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );

      // إرجاع رسالة نجاح مع البيانات
      return {
        message: response.data?.message || "Category updated successfully",
        data: response.data?.result || response.data,
        success: true
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error updating category"
      );
    }
  }
);

// Update category status
export const updateCategoryStatus = createAsyncThunk(
  "category/updateCategoryStatus",
  async (id, thunkAPI) => {
    try {

      
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.post(
        `${BASE_URL}/update_category_status/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      // إرجاع معرف العنصر مع رسالة نجاح
      return {
        id: id,
        message: response.data?.message || "Category status updated successfully",
        success: true
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error updating category status"
      );
    }
  }
);

// Fetch single category
export const fetchCategory = createAsyncThunk(
  "categories/fetchCategory",
  async (id, thunkAPI) => {
    try {
 
      
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.post(
        `${BASE_URL}/update_new_category/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      // إرجاع البيانات مع رسالة نجاح
      return {
        message: response.data?.message || "Category fetched successfully",
        data: response.data?.result || response.data,
        success: true
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error fetching category"
      );
    }
  }
);

// Add new category
export const addCategory = createAsyncThunk(
  "categories/addCategory",
  async (categoryData, thunkAPI) => {
    try {
   
      
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const formData = new FormData();
      formData.append("title_ar", categoryData.title_ar);
      if (categoryData.image) {
        formData.append("image", categoryData.image);
      }



      const response = await axios.post(
        `${BASE_URL}/add_new_category`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );


      // إرجاع رسالة نجاح مع البيانات
      return {
        message: response.data?.message || "Category added successfully",
        data: response.data?.result || response.data,
        success: true
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error adding category"
      );
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (id, thunkAPI) => {
    try {

      
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const deleteUrl = `${BASE_URL}/delete_category/${id}`;


      const response = await axios.delete(
        `${BASE_URL}/delete_category/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          }
        }
      );


      // إرجاع معرف العنصر المحذوف مع رسالة نجاح
      // حتى لو كانت الاستجابة فارغة، نعتبر أن الحذف نجح
      return {
        id: id,
        message: response.data?.message || "تم حذف الفئة بنجاح",
        success: true
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Failed to delete category"
      );
    }
  }
);

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
    updateSuccess: null,
    currentCategory: null,
    isLoading: false,
    selectedCategoryForEdit: null
  },
  reducers: {
    clearCategoryState: (state) => {
      state.error = null;
      state.success = false;
      state.updateSuccess = false
    },
    clearCurrentCategory: (state) => {
      state.currentCategory = null;
      state.isLoading = false;
      state.error = null;
    },
    setSelectedCategoryForEdit: (state, action) => {
      state.selectedCategoryForEdit = action.payload;
    },
    clearSelectedCategoryForEdit: (state) => {
      state.selectedCategoryForEdit = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.result || [];
        state.pagination = action.payload.pagination || {};
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addCategory.pending, (state) => {
        state.addLoading = true;
        state.addError = null;
        state.addSuccessMessage = null;
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.addSuccessMessage =
          action.payload.message || "Category added successfully";
      })
      .addCase(addCategory.rejected, (state, action) => {
        state.addLoading = false;
        state.addError = action.payload;
      })
      .addCase(updateCategory.fulfilled, (state) => {
        state.updateSuccess = true;
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateCategoryStatus.fulfilled, (state, action) => {
        // تحديث حالة الفئة في القائمة
        const categoryIndex = state.data.findIndex(cat => cat.id === action.payload.id);
        if (categoryIndex !== -1) {
          state.data[categoryIndex].status = action.payload.status;
        }
      })
      .addCase(updateCategoryStatus.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteCategory.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(deleteCategory.fulfilled, (state, action) => {
  state.loading = false;
  state.error = null;
        // حذف العنصر من القائمة
        state.data = state.data.filter((item) => item.id !== action.meta.arg);
})
      .addCase(deleteCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCategory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentCategory = action.payload.data || action.payload.result || action.payload;
        state.error = null;
      })
      .addCase(fetchCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export const { clearCategoryState, clearCurrentCategory, setSelectedCategoryForEdit, clearSelectedCategoryForEdit } = categorySlice.actions;
export default categorySlice.reducer;
